<div class="flex-grow-1  d-flex flex-row player-buttons-panel" *ngIf="showStatusPanel">
  <div class="flex-grow-1 d-flex flex-row mt-2 " *ngIf="isPlayerChangeAvailable">
    <div class="text-center flex-grow-1 clickable black-gray"  translate (click)="changePlayer()">
      CourtBooking.PlayerChange
    </div>
  </div>

  <div class="flex-grow-1 d-flex flex-row  mt-2" *ngIf="isCheckInAvailable">
    <div class="text-center flex-grow-1 clickable bay-club-light-blue"  (click)="checkIn()"
      translate>
      CourtBooking.PlayerCheckIn</div>
  </div>
</div>
